<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2>Location Type - {{ subTitle  }}</h2>
			</b-col>
			<!--Gear Icon-->
			<b-col lg="6">
				<b-dropdown :disabled="edit" class="pull-right" right variant="info" no-caret>
					<template slot="button-content">
							<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item @click="editservice">Edit</b-dropdown-item>
					<b-dropdown-item @click="deleteLocationType">Delete</b-dropdown-item>
				</b-dropdown>
			</b-col>
		</div>
		<div class="card location-information">
	    	<b-row v-if="loadingData">
              	<b-col cols="12" sm="12" md="12" lg="12">
                 	<p class="text-center">
                  		<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
                 	</p>
              	</b-col>
            </b-row>
				<div v-else>
				      	<b-row>
				      		<b-col md="8">
										<b-form-group label="Location Type Name" label-for="locationtypename" :label-cols="4" horizontal>
											<b-form-input class="plaintext-input" plaintext v-show="!edit" id="locationtypename" v-model="model.name" type="text" :readonly="!edit"></b-form-input>
											<b-form-input class="plaintext-input" v-show="edit" id="locationtypename" v-model="model.name" type="text"></b-form-input>
										</b-form-group>
	
										<div v-if="edit" slot="footer">
											<b-button @click="updateservice" size="sm" variant="primary"><i class="fa fa-edit"></i> Update</b-button>
											<b-button  @click="editservice" size="sm" ><i class="fa fa-ban"></i> Cancel</b-button>
					        			</div>
							</b-col>
						</b-row>
        		</div>
		</div>
	</div>
</template>

<script>
	// ********** imports ************ //
	import Vue from 'vue'
	import locationtypes_service from './locationtypes_service'

	
	export default {
		name: 'm_location_type',
		props: {
			id: {
				type: String,
				default: 0
			}
		},
		created: function() {
			this.getLocationTypeData()
		},
		data() {
			return {
				originalData: null,
				edit: false,
				loadingData: true,
				model: {
					id: null,
					name: ''
				},
				subTitle : ''
			}
		},
		methods: {
			editservice() {
				if (this.edit) {
					this.edit = false
					this.restoreOriginalData()
				} else {
					this.edit = true
				}
			},
			restoreOriginalData() {
				let model = this.originalData
				this.model = JSON.parse(JSON.stringify(model))
			},
			getLocationTypeData() {
				locationtypes_service.getBy(this.id)
					.then(data => {
					if (data[0] == 'success') {
							this.originalData = data[1]
							this.restoreOriginalData()
							this.subTitle = data[1].name
							this.loadingData = false           
                	} else {
							this.$swal(data[0], data[1], data[0])
							this.loadingData = false
                	}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			okToUpdate() {
				if (this.model.name === undefined || this.model.name.trim().length == 0) {
					this.$swal('Alert!', 'Location Type can not be empty', 'warning')
					return false
				} 
				return true
			},
			updateservice() {
				if (!this.okToUpdate()) {
					return
				}
					locationtypes_service.update(this.id, this.model.name)
						.then((data) => {
							this.$swal(data[0], data[1], data[0])
							if (data[0] == 'success') {
								this.getLocationTypeData
							}
						})
						.catch(error => {
							this.$swal('Error', 'Server not response. ' + error, 'error')
						})
						this.edit=false
			},
			deleteLocationType() {

				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to delete this Location Type: " + this.subTitle + " ?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						locationtypes_service.delete(this.id)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									this.$router.push('/location_types')
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/views/location_types/m_location_type.vue